// extracted by mini-css-extract-plugin
export var typingIndicator = "_nc-0";